
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as component_45stubkJrm_ncqLRUokahMaIBKeeBfPQzfk5wRuAVFeQqSh1I } from "/srv/projects/www.cultus-dresden.de/site/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_6385feb2f098e97a5a7aac402008945c/node_modules/nuxt/dist/pages/runtime/component-stub.js";
import { default as component_45stubkJrm_ncqLRUokahMaIBKeeBfPQzfk5wRuAVFeQqSh1IMeta } from "/srv/projects/www.cultus-dresden.de/site/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_6385feb2f098e97a5a7aac402008945c/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
export default [
  {
    name: "location-detail",
    path: "/standorte/:location_slug()",
    component: () => import("/srv/projects/www.cultus-dresden.de/site/app/pages/standorte/[location_slug].vue").then((m) => Object.assign(m.default, { __name: "location-detail" }))
  },
  {
    name: "joboffer-detail",
    path: "/stellenangebote/:joboffer_slug()",
    component: () => import("/srv/projects/www.cultus-dresden.de/site/app/pages/stellenangebote/[joboffer_slug].vue").then((m) => Object.assign(m.default, { __name: "joboffer-detail" }))
  },
  {
    name: "news-list",
    path: "/aktuelles",
    component: () => import("/srv/projects/www.cultus-dresden.de/site/app/pages/aktuelles/index.vue").then((m) => Object.assign(m.default, { __name: "news-list" }))
  },
  {
    name: "location-list",
    path: "/standorte",
    component: () => import("/srv/projects/www.cultus-dresden.de/site/app/pages/standorte/index.vue").then((m) => Object.assign(m.default, { __name: "location-list" }))
  },
  {
    name: "article-detail",
    path: "/:article_slug()",
    component: () => import("/srv/projects/www.cultus-dresden.de/site/app/pages/[article_slug].vue").then((m) => Object.assign(m.default, { __name: "article-detail" }))
  },
  {
    name: "home",
    path: "/",
    component: () => import("/srv/projects/www.cultus-dresden.de/site/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: "home" }))
  },
  {
    name: component_45stubkJrm_ncqLRUokahMaIBKeeBfPQzfk5wRuAVFeQqSh1IMeta?.name,
    path: "/sitemap.xml",
    component: Object.assign(component_45stubkJrm_ncqLRUokahMaIBKeeBfPQzfk5wRuAVFeQqSh1I, { __name: component_45stubkJrm_ncqLRUokahMaIBKeeBfPQzfk5wRuAVFeQqSh1IMeta?.name })
  }
]